import React from 'react';

function TestButttons({ numAnswer, testAnswer }) {

    var indents = [];
    for (var i = 0; i < numAnswer; i++) {
        indents.push(<span className='indent' key={i}></span>);
    }
    return (
        <div className="test-buttons">
            {
                indents.map((item, index) => {
                    let style = { backgroundColor: "white", color: "black" }
                    if (testAnswer.has(index + 1))
                        style = { backgroundColor: "blue" }
                    return (
                        <button style={style} key={index}>{index + 1}</button>
                    )
                })
            }


        </div>

    );
}

export default TestButttons;